<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir item"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        itemRequisicao: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de item da requisição',
                html: `Confirma a exclusão do item ${this.itemRequisicao.descricao} (${this.itemRequisicao.idItemContrato}) da requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirItem()
                }
            })
        },

        excluirItem() {
            this.$emit('excluirItem', this.itemRequisicao.idItemRequisicao)
        }
    },

    computed: {},

    created() {}
}
</script>
